import React from 'react';

const JcbPaymentSvg = (props) => (
    <svg viewBox="0 0 48 32" {...props}>
        <path
            fill="#FFF"
            d="M3 31.5C1.6 31.5.5 30.4.5 29V3C.5 1.6 1.6.5 3 .5h42c1.4 0 2.5 1.1 2.5 2.5v26c0 1.4-1.1 2.5-2.5 2.5H3z"
        />
        <path
            fill="#004099"
            d="M45 1c1.1 0 2 .9 2 2v26c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h42m0-1H3C1.3 0 0 1.3 0 3v26c0 1.7 1.3 3 3 3h42c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#00A551"
            d="M28.3 27h3.9c1.4 0 2.9-1.3 2.9-2.9V5h-3.7c-1.7 0-3.1 1.1-3.1 3v19z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#EC1C24"
            d="M20.6 27h3.9c1.4 0 2.9-1.3 2.9-2.9V5h-3.7c-1.7 0-3.1 1.1-3.1 3v19z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#00A0E3"
            d="M12.9 27h3.9c1.4 0 2.9-1.3 2.9-2.9V5H16c-1.7 0-3.1 1.1-3.1 3v19z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#FFF"
            d="M35.1 17.1c0 .6-.6 1.1-1.3 1.1h-5.4v-4.7h5.4c.6 0 1.2.6 1.2 1.2s-.6 1.2-1.2 1.2c.7 0 1.3.5 1.3 1.2zm-4.6-1.4h1.7c.4 0 .8-.4.8-.8s-.4-.8-.8-.8h-1.7v1.6zm1.7 2c.4 0 .8-.4.8-.8s-.4-.8-.8-.8h-1.7v1.6h1.7zm-5-.3c-1 .2-1.9.3-2.4.3-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8c.5 0 1.4.1 2.4.3v-.9h-4.1c-1.3 0-2.3 1.1-2.3 2.3 0 1.3 1.1 2.3 2.3 2.3h4.1v-.7zM14 16.5h-1.1c.3 1.2 1.7 2.1 3.3 2.1 1.4 0 3.4-.8 3.4-2.3v-2.8h-2.4v2.8c0 .8-.6 1.4-1.5 1.4-.8.1-1.6-.4-1.7-1.2z"
        />
    </svg>
);

JcbPaymentSvg.displayName = 'JcbPaymentSvg';
export default JcbPaymentSvg;
